<div class="grid-row {{ columns }}" [ngClass]="reflectClass">
  <ng-content></ng-content>
</div>
